export default [
  { url: `https://www.github.com/jesdavpet` },
  { url: `https://www.linkedin.com/in/jesdavpet` },
  { url: `https://www.twitter.com/jesdavpet` }
]



// WEBPACK FOOTER //
// ./src/data/socialLinks.js